import { Card, CardContent, CardMedia, Typography } from '@mui/material';
import * as React from 'react';
import Box from '@mui/material/Box';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import InfoIcon from '@mui/icons-material/Info';
import { useTranslation } from 'react-i18next';
import { useRestaurantData } from '../../provider/RestaurantDataContext';
import { HOMEPAGE, MENU_CARD_URL } from '../../utils/Constants';
import { useCallback } from 'react';

export type SwipeableDrawerHandle = {
    toggleDrawer: () => void;
};

interface MenuItem {
    text: string,
    icon: React.ReactElement,
    onCLick: () => void,
}

export default React.forwardRef((props, ref) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    let {pathname} = useLocation();
    const [opened, setOpened] = React.useState(false);
    const { restaurantData } = useRestaurantData();
    const anchor = 'left';

    React.useImperativeHandle(
        ref,
        () => ({
            toggleDrawer: () => { setOpened(!opened); },
        }),
        [opened]);

    const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
        if (
            event &&
            event.type === 'keydown' &&
            ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
        ) {
            return;
        }

        setOpened(open);
    };

    const navigateToMenuItem = useCallback((path: string) => {
        const afterBase = pathname.substring(pathname.indexOf(HOMEPAGE)+HOMEPAGE.length+1);
        navigate(`${HOMEPAGE}/${afterBase.substring(0,afterBase.indexOf('/'))}/${path}`, { relative: "path" });
        setOpened(false);
    }, [navigate,pathname]);

    const iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
    const menuList: MenuItem[] = [
        { text: t('menu'), icon: <RestaurantMenuIcon />, onCLick: () => navigateToMenuItem(MENU_CARD_URL) },
        { text: t('openingHours'), icon: <AccessTimeIcon />, onCLick: () => navigateToMenuItem('openinghours') },
        { text: t('contact'), icon: <ContactMailIcon />, onCLick: () => navigateToMenuItem('contact') },
        ...(restaurantData.qrMenuProperties?.showAboutUs ? [{ text: t('aboutUs'), icon: <InfoIcon />, onCLick: () => navigateToMenuItem('about-us') }] : []),
        { text: t('allergens'), icon: <HealthAndSafetyIcon />, onCLick: () => navigateToMenuItem('allergens') },
    ];

    const secondaryMenu: MenuItem[] = [
        //{ text: t('joinQRM'), icon: <QrCode2Icon />, onCLick: () => { navigate(basePath + '/join-qrmenu', { relative: "path" }); setOpened(false); } },
    ]

    const list = () => (
        <Box
            sx={{ width: 250 }}
            role="presentation"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
        >
            <Card style={{ display: 'flex', justifyContent: 'center', alignItems: "center" }}>
                <CardContent style={{ paddingBottom: '1rem', justifyContent: 'center' }}>
                    <CardMedia
                        component="img"
                        height={'auto'}
                        image={restaurantData.imageUrl}
                        alt={restaurantData.name}
                        sx={{ maxWidth: '100%', maxHeight: '5rem', width: 'auto' }}
                    />
                    <Typography style={{ textAlign: 'center', paddingTop: '0.313rem' }}>
                        {restaurantData.name}
                    </Typography>
                </CardContent>
            </Card>
            <List>
                {menuList.map((menuItem) => (
                    <ListItem key={menuItem.text} disablePadding>
                        <ListItemButton onClick={() => menuItem.onCLick()}>
                            <ListItemIcon>
                                {menuItem.icon}
                            </ListItemIcon>
                            <ListItemText primary={menuItem.text} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            <Divider />
            <List>
                {secondaryMenu.map((menuItem) => (
                    <ListItem key={menuItem.text} disablePadding>
                        <ListItemButton onClick={() => menuItem.onCLick()}>
                            <ListItemIcon>
                                {menuItem.icon}
                            </ListItemIcon>
                            <ListItemText primary={menuItem.text} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    );

    return (
        <SwipeableDrawer
            disableBackdropTransition={!iOS} disableDiscovery={iOS}
            anchor={anchor}
            open={opened}
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}
        >
            {list()}
        </SwipeableDrawer>
    );
}
);
